import { render, staticRenderFns } from "./NhsafeOrganizationChart.vue?vue&type=template&id=2213be32&scoped=true"
import script from "./NhsafeOrganizationChart.vue?vue&type=script&lang=js"
export * from "./NhsafeOrganizationChart.vue?vue&type=script&lang=js"
import style0 from "./NhsafeOrganizationChart.vue?vue&type=style&index=0&id=2213be32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213be32",
  null
  
)

export default component.exports